export const DEFAULT_GROUP_KEY = 'default';
const merge = (a, b, merger) => [...new Set([...Object.keys(a), ...Object.keys(b)])].reduce((acc, key) => ({ ...acc, [key]: merger(a[key], b[key]) }), {});
const deepMerge = (a, b) => merge(a, b, (a, b) => typeof a === 'object' && typeof b === 'object'
    ? deepMerge(a, b)
    : a !== undefined
        ? a
        : b);
export const compose = (...dictionaries) => dictionaries.reduce((completeDictionary, dictionary) => deepMerge(completeDictionary, dictionary), {});
export const gracefullyLookupMessage = (pathSegments, dictionary, defaultGroupKey = DEFAULT_GROUP_KEY) => {
    let msg = undefined;
    const pathSections = typeof pathSegments === 'string' ? pathSegments.split('.') : pathSegments;
    let segmentStart = 0;
    while (!msg && segmentStart < pathSections.length) {
        msg = lookupMessage(pathSections.slice(segmentStart++), dictionary, defaultGroupKey);
    }
    return msg;
};
export const lookupMessage = (pathSegments, dictionary, defaultGroupKey = DEFAULT_GROUP_KEY) => {
    if (!dictionary)
        return undefined;
    const pathSections = typeof pathSegments === 'string' ? pathSegments.split('.') : pathSegments;
    if (!pathSections || pathSections.length === 0) {
        return typeof dictionary === 'string'
            ? dictionary
            : defaultGroupKey && typeof dictionary[defaultGroupKey] === 'string'
                ? dictionary[defaultGroupKey]
                : undefined;
    }
    else {
        if (typeof dictionary === 'string') {
            return dictionary;
        }
        else {
            const childDictionary = dictionary[pathSections[0]];
            const message = childDictionary
                ? lookupMessage(pathSections.slice(1), childDictionary)
                : undefined;
            return message
                ? message
                : defaultGroupKey && typeof dictionary[defaultGroupKey] === 'string'
                    ? (dictionary[defaultGroupKey])
                    : undefined;
        }
    }
};
